<template>
  <div id="landingPageReviewBody" class=" centercenter">
    <div id="starreview">
      <div  class="flexwrap centercenter ">
        <h2>4.6 <span style="font-size: 0.8em;"> /5 </span></h2>
        <i class="fa-solid fa-star"></i>
        <i class="fa-solid fa-star"></i>
        <i class="fa-solid fa-star"></i>
        <i class="fa-solid fa-star"></i>
        <i class="fa-duotone fa-star-half"></i>
      </div>
    </div>
    <span class="flexwrap centercenter" style="font-size: 0.8em">sur un sondage réalisé auprès de nos utilisateurs</span>
    <div id="userreview"><strong>Le site est bien pensé, [...] clair et assez fluide. En plus il évolue régulièrement, c'est top.</strong><span> - Maxime, utilisateur Premium</span></div>
    <component id="reviewCard" :is="isMobile?'carousel':'div'"
               :perPage="1" :minSwipeDistance="50" :paginationEnabled="true" :touchDrag="true" :autoplay="false" :loop="true"
               :autoplayTimeout="3500" paginationActiveColor="var(--goalBackgroundColor2)" paginationColor="#ffffff88" :paginationPadding="5" >
      <component class="reviewItemContainer" :is="isMobile?'slide':'div'">
        <img class="reviewImg" src="@/assets/landing_page/articlemondedesados.png"
             alt="Le Monde des Ados : Le site Learn and Watch te propose d'apprendre l'anglais avec les séries [...]. A chaque épisode, on te propose une session de vocabulaireavant de le regarder.">
      </component>
      <component class="reviewItemContainer" :is="isMobile?'slide':'div'">
        <img class="reviewImg" src="@/assets/landing_page/articleblogs.png">
        <div class="reviewItem flexwrap centercenter">
          <div><strong>Learn and Watch vous donne un coup de pouce pour regarder les séries en VO sous-titrées anglais.</strong><span> - Devenir Bilingue</span></div>
          <div style="display: flex; flex-direction: column"><strong>La plateforme vous accompagne dans l’apprentissage de l’anglais avec les séries</strong><span> - I speak spoke spoken</span></div>
          <div><strong>Learn and Watch est un projet prometteur qui présente une méthode efficace d’apprentissage de l’anglais avec vos séries préférées.</strong><span> - Lubie en série</span></div>
        </div>
      </component>
      <component class="reviewItemContainer" :is="isMobile?'slide':'div'">
        <img class="reviewImg" src="@/assets/landing_page/facebookgroups.png">
        <div class="reviewItem flexwrap centercenter ">
          <div><strong>C'est génial... Bravo et merci pour ce travail monumental!</strong> - Amandine, Professeur d'anglais</div>
          <div><strong>What a great job! Thanks a lot</strong> - France, Professeur d'anglais</div>
          <div><strong>That's brilliant!</strong> - Terri, Professeur d'anglais</div>
          <div><strong>Mais c'est génial !! Bravo !!</strong> - Gwen, Professeur d'anglais</div>
        </div>

      </component>
    </component>

  </div>

</template>

<script>
import {Carousel, Slide} from "vue-carousel";
import {mapGetters} from "vuex";

export default {
  name: "landingPageReview",
  components: {
    Carousel,
    Slide,},

  computed: {
    ...mapGetters('global', [
      'isMobile',
    ]),
  },
}
</script>

<style scoped>

#landingPageReviewBody{
  display: flex;
  flex-direction: column;
  transform: translateX(-6vw);
}

#reviewCard{
  display: grid;
  grid-auto-flow: column;
  grid-gap: 2vw;
}

#userreview{
  margin-top: 2vw;
  display: flex;
  flex-direction: column;
  margin-bottom: 2vw;
}
#starreview{
  font-size: 2em;
  width: 100%;
  align-items: center;
  align-content: center;
}
#starreview>*>i{
  margin: 0 0.5vw 0 0.5vw;
  padding-bottom: 0.2vw;
  color: #f3b649;
}

.reviewItemContainer{
  width: 18vw;
  height: 18vw;
  position: relative;
}

.reviewImg{
  width: 18vw;
  height: 18vw;
  border-radius: 1vw;
  position: absolute;
}

.reviewItem{
  height: 14.5vw;
  width: 16vw;
  border-radius: 1vw;
  background-size: contain;
  font-size: 0.8em;
  padding: 3vw 1vw 0.5vw 1vw;
  text-align: left;
  position: absolute;
}
.reviewItem>div{
  margin-bottom: 0.25vw;
  margin-top: 0.25vw;
  text-align: left;
  width: 100%;
}
@media screen and (max-device-width: 767px) {
  #landingPageReviewBody{
    transform: translateX(0);
  }
  #reviewCard{
    height: fit-content;
    width: 100vw;
    display: block;
    justify-self: center;
  }

  #starreview{
    font-size: 2em;
    width: 100%;
    align-items: center;
    align-content: center;
    margin-top: 6vw;
  }
  #starreview>*>i{
    margin: 0 1vw 0 1vw;
    padding-bottom: 0.6vw;
    color: #f3b649;
  }

  .reviewItemContainer{
    width: 84vw;
    height: 84vw;
    position: relative;
  }


  .reviewImg{
    width: 84vw;
    height: 84vw;
    border-radius: 5vw;
    position: absolute;
    margin: 0 8vw 0 8vw;
  }

  .reviewItem{
    height: 70vw;
    min-width: 72vw;
    border-radius: 5vw;
    background-size: contain;
    font-size: 0.9em;
    padding: 12vw 6vw 2vw 6vw;
    margin: 0 8vw 0 8vw;
  }
  .reviewItem>span{
    margin-bottom: 1vw;
    margin-top: 1vw;
  }

  #userreview{
    margin-top: 6vw;
    margin-bottom: 6vw;
  }
}
</style>